import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ShareLinkService } from 'src/app/services/share-link/share-link.service';

@Component({
  selector: 'app-share-link-menu',
  templateUrl: './share-link-menu.page.html',
  styleUrls: ['./share-link-menu.page.scss'],
})
export class ShareLinkMenuPage implements OnInit {
  @Input() url = '';
  @Input() title = '';
  @Input() copiedToast = 'Link copied.';
  canNativeShare = false;

  constructor(
    private popCtrl: PopoverController,
    private shareLinkService: ShareLinkService
  ) { }

  ngOnInit() {
    this.canNativeShare = !!(navigator as any)?.share;
  }

  async invoke(action: 'copy' | 'share' | 'outlook' | 'teams' | 'text') {
    await this.popCtrl.dismiss();

    switch (action) {
      case 'copy':
        await this.shareLinkService.copyToClipboard(this.url, this.copiedToast, 'share-link-menu.copy');
        break;
      case 'share':
        await this.shareLinkService.shareNative(this.url, this.title, 'share-link-menu.share');
        break;
      case 'outlook':
        this.shareLinkService.shareViaOutlook(this.url, this.title);
        break;
      case 'teams':
        this.shareLinkService.shareViaTeams(this.url, this.title);
        break;
      case 'text':
        this.shareLinkService.shareViaText(this.url, this.title);
        break;
    }
  }

}
